module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/perm-dis-55e1d80f2b67ec9dce54edc002b2d2bd.png";